<template>
  <div class="yh_harvest">
    <section class="harvest_banner">
      <div class="harvest_search_box" id="harvest_search_box4">
        <h4 class="form_h4">【社科联资料库】</h4>
        <el-form ref="form">
          <p class="harvest_type">
            <el-radio v-model="data_type" label="1">社科联大事记文档</el-radio>
            <el-radio v-model="data_type" label="2">社科联大事记图片</el-radio>
          </p>

          <div class="form_param" v-show="data_type == 1">
            <el-radio-group v-model="year">
              <el-radio-button class="years_check" v-for="x in year_arr" :label="x" :key="x">{{x}}</el-radio-button>
            </el-radio-group>
          </div>
          <!--、、、、、、、、、、、、、、、、、、、、、、、、、社科联大事记文档end-->
          <!--、、、、、、、、、、、、、、、、、、、、、、、、、社科联大事记图片start-->
          <div class="form_param" v-show="data_type == 2">
            <el-form-item label-width="77px" label="大事纪标题" class="harvest_param">
              <el-input v-model="memorabilia_name" class="topic_type"></el-input>
            </el-form-item>
            <el-button type="primary" class="harvest_btn" @click="search_fn">搜索</el-button>
            <el-button class="harvest_btn gray_btn" @click="reset_fn">重置</el-button>
          </div>
        </el-form>
      </div>
    </section>

    <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库表格-->
    <section class="harvest_tab_box">
      <div class="width1000">
        <el-table
          :data="tab_list[current_page]"
          class="width1000"
          width="1000"
          v-show="data_type == 1"
        >
          <el-table-column label="序号" prop="idx" width="50"></el-table-column>
          <el-table-column prop="name" label="期刊名"></el-table-column>
          <el-table-column prop="a" width="100" label="周期"></el-table-column>
          <el-table-column prop="b" width="110" label="期号"></el-table-column>
          <el-table-column prop="c" label="主办单位"></el-table-column>
          <el-table-column prop="d" width="90" label="阅读数"></el-table-column>

          <el-table-column fixed="right" width="90" label="操作">
            <template slot-scope="scope">
              <span @click.prevent="to_memorabilia(scope.row.id)" class="msg_btn pointer">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、年鉴库表格完成-->
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库开始-->
        <el-table
          :data="tab_list[current_page]"
          class="width1000"
          width="1000"
          v-show="data_type == 2 "
        >
          <el-table-column label="序号" prop="idx" width="50"></el-table-column>
          <el-table-column prop="name" label="大事记标题"></el-table-column>

          <el-table-column prop="g" label="阅读数" width="130"></el-table-column>
          <el-table-column fixed="right" width="180" label="操作">
            <template slot-scope="scope">
              <span @click.prevent="to_memorabilia_img(scope.row.id)" class="msg_btn pointer">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <!--、、、、、、、、、、、、、、、、、、、、、、、、、获奖数据库开始-->
        <el-pagination
          v-show="data_len > 0"
          class="mid"
          :page-size="num_s"
          @current-change="get_page"
          background
          layout="prev, pager, next"
          :total="data_len"
        ></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { yh_post } from "../../api";
import { fn_pos_mid } from "../../assets/js/harvest";
import { sort_arr } from "../../assets/js/public";
export default {
  data() {
    return {
      data_type: "1",
      memorabilia_name: "",
      year: "",
      year_arr: [
        "全部往期",
        "1979年",
        "1980年",
        "1981年",
        "1982年",
        "1983年",
        "1984年",
        "1985年",
        "1986年",
        "1987年",
        "1988年",
        "1989年",
        "1990年",
        "1991年",
        "1992年",
        "1993年",
        "1994年",
        "1995年",
        "1996年",
        "1997年",
        "1998年",
        "1999年",
        "2000年",
        "2001年",
        "2002年",
        "2003年",
        "2004年",
        "2005年",
        "2006年",
        "2007年",
        "2008年",
        "2009年",
        "2010年",
        "2011年",
        "2012年",
        "2013年",
        "2014年",
        "2015年",
        "2016年"
      ],
      topic_type_arr: [
        {
          name: "全部",
          id: -1
        },
        {
          name: "重点",
          id: 1
        },
        {
          name: "一般",
          id: 2
        }
      ],
      current_page: 0,
      tab_data1: [],
      tab_data2: [],
      tab_list: [],
      data_len: 0, //数据总数
      num_s: 10,
      position_: {
        marginLeft: 0,
        marginTop: 0
      }
    };
  },
  methods: {
    search_fn() {
      // if(this.memorabilia_name == ""){
      // 	this.$alert("请填写大事记标题", '温馨提示', {
      //       confirmButtonText: '确定'
      //     });
      // 	return;
      // };
      this.tab_data2 = require("../../../static/json/top.3.json");
      this.data_len = this.tab_data2.length;
      this.tab_list = sort_arr(this.tab_data2, this.num_s);
      this.$api.axios_database2(this.memorabilia_name).then(res => {
        this.tab_data2 = res.data;
        this.data_len = this.tab_data2.length;
        this.tab_list = sort_arr(this.tab_data2, this.num_s);
      });
    },
    reset_fn() {
      this.year = "";
      this.memorabilia_name = "";
    },
    to_memorabilia(id) {
      this.$router.push({ path: "/memorabilia", query: { id: id } });
    },
    to_memorabilia_img(id) {
      this.$router.push({ path: "/memorabilia_img", query: { id: id } });
    },
    get_page(d) {
      this.current_page = d - 1;
    }
  },
  mounted() {
    fn_pos_mid("harvest_search_box4");
  },
  created: function() {
    if (localStorage.getItem("doc_token") == null) {
      this.$router.push({ path: "/login" });
    }
  },
  updated() {
    fn_pos_mid("harvest_search_box4");
  },
  watch: {
    year: function(x) {
      if (x != "") {
        this.tab_data1 = require("../../../static/json/top.3.json");
        this.data_len = this.tab_data1.length;
        this.tab_list = sort_arr(this.tab_data1, this.num_s);
        this.$api.axios_database1(this.year).then(res => {
          this.tab_data1 = res.data;
          this.data_len = this.tab_data1.length;
          this.tab_list = sort_arr(this.tab_data1, this.num_s);
        });
      }
    },
    data_type: function(x) {
      this.reset_fn();
      this.tab_list = [];
      this.data_len = 0;
      this.current_page = 0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@import url("../../assets/css/index");*/

@import url("../../assets/css/else.css");
@import url("../../assets/css/harvest.css");
</style>


// WEBPACK FOOTER //
// src/components/harvest/database.vue